/* eslint-disable no-unused-vars */
/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */
if(window.location.href.includes('specto') || window.location.href.includes('localhost') || window.location.href.includes('cms.mojedelo.com') || window.location.href.includes('delodajalec.mojedelo')) {
  setTimeout(() => {
    dispatchEvent(new Event('spectoCmsContentLoaded'));
  }, 500);
}

window.addEventListener('spectoCmsContentLoaded', () => {
  window.injection = (() => {
    const breakpointSm = 767;
    const breakpointMd = 1023;
    const breakpointLg = 1171;

    // Return Window Width
    function windowWidth() {
      return window.innerWidth || document.documentElement.clientWidth;
    }

    function attachEvent(selector, event, handler) {
      document.addEventListener(
        event,
        (ev) => {
          let { target } = ev;
          for (; target && target !== document; target = target.parentNode) {
            if (target.matches(selector)) {
              try {
                handler.call(target, ev);
              } catch (e) {
                console.error(e);
              }
              break;
            }
          }
        },
        false,
      );
    }

    function animate(elementToAnimate, type) {
      switch (type) {
        case 'show':
          elementToAnimate.classList.add('is-visible');
          elementToAnimate.classList.remove('is-hidden');
          break;
        case 'hide':
          elementToAnimate.classList.add('is-hidden');
          elementToAnimate.classList.remove('is-visible');
          break;
        default:
          break;
      }
    }

    function validateEmailInput(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    function debounce(func, wait, immediate) {
      let timeout;
      return function(...args) {
        const context = this;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    class ResponsiveBackgroundImage {
      constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';

        this.img.addEventListener('load', () => {
          this.update();
        });

        if (this.img.complete) {
          this.update();
        }
      }

      update() {
        const src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
        if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = `url("${this.src}")`;
        }
      }
    }

    const elements = document.querySelectorAll('[data-responsive="responsive-bg-image"]');

    function responsiveBgImagesLoop() {
      for (let i = 0; i < elements.length; i += 1) {
        new ResponsiveBackgroundImage(elements[i]);
      }
    }

    const slideUp = (target, duration) => {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = `${duration}ms`;
      target.style.boxSizing = 'border-box';
      target.style.height = `${target.offsetHeight}px`;
      // eslint-disable-next-line no-unused-expressions
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    };

    const slideDown = (target, duration, displayType) => {
      target.style.removeProperty('display');

      let { display } = window.getComputedStyle(target);

      // eslint-disable-next-line no-unused-expressions
      display === 'none' ? (display = displayType) : null;
      target.style.display = display;

      target.style.display = display;
      const height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      // eslint-disable-next-line no-unused-expressions
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = `${duration}ms`;
      target.style.height = `${height}px`;
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    };

    const slideToggle = (target, duration, displayType) => {
      /* Slide-toggle logic */

      if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration, displayType);
        // eslint-disable-next-line no-else-return
      } else {
        return slideUp(target, duration, displayType);
      }
    };

    function calcVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    calcVh();
    const debounceCalcVh = debounce(() => {
      calcVh();
    }, 100);

    function clickHandler(offsetTop) {
      // eslint-disable-next-line no-restricted-globals
      scroll({
        top: offsetTop,
        behavior: 'smooth',
      });
    }

    function addAnimateClass(el) {
      if (el) {
        setTimeout(() => {
          el.classList.add('is-animated');
        }, 400);
      }
    }

    function setHeight(el, val) {
      // eslint-disable-next-line no-param-reassign
      if (typeof val === 'function') val = val();
      // eslint-disable-next-line no-param-reassign
      if (typeof val === 'string') el.style.height = val;
      // eslint-disable-next-line no-param-reassign
      else el.style.height = `${val}px`;
    }

    const equalheight = function(container) {
      let currentTallest = 0;
      let currentRowStart = 0;
      // eslint-disable-next-line no-array-constructor
      const rowDivs = new Array();
      let $el;
      const topPosition = 0;

      Array.from(document.querySelectorAll(container)).forEach((el, i) => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = 'auto';
        const topPostion = el.offsetTop;
        if (currentRowStart !== topPostion) {
          let currentDiv = 0;

          // eslint-disable-next-line no-plusplus
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            setHeight(rowDivs[currentDiv], currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPostion;
          currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
          rowDivs.push(el);
        } else {
          rowDivs.push(el);
          // eslint-disable-next-line operator-linebreak
          currentTallest =
            currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
              ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
              : currentTallest;
        }

        let currentDiv = 0;
        // eslint-disable-next-line no-plusplus
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          setHeight(rowDivs[currentDiv], currentTallest);
        }
      });
    };

    const isVisible = (elm) => {
      const rect = elm.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    };

    function addScrollingClass() {
      const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
      document.body.classList.toggle('is-scrolled', topOffset > 20);
    }

    const setOffsets = () => {
      const header = document.querySelector('header');
      const main = document.querySelector('main');

      if (!header) {
        return
      }

      const headerHeight = (header.offsetHeight - 1) + (header.querySelector('.header-main__bottom-nav')?.offsetHeight || 0);

      main.style.paddingTop = `${headerHeight}px`;
      main.style.setProperty('--top-offset', `${headerHeight}px`);
    };


    const isFractal = () =>
      !!document.querySelector('.Frame') ||
      window.location.href.includes('localhost:3010') ||
      window.location.href.includes('/preview/components/');

    // *******************************************************************************
    // Get nonce for static pages
    // *******************************************************************************
    const getNonceForAction = async (formAction) => {
      if (isFractal()) {
        return Promise.resolve('');
      }

      try {
        const formDataNonce = {
          action: 'getNonceField',
          nonce_action: formAction,
        };

        const response = await axios.post(localData.apiURL, formDataNonce, {});
        return response.data.data.nonce;
      } catch (error) {
        console.error(error);
      }
    };

    // *******************************************************************************
    // Form helper
    // *******************************************************************************
    const joinActiveItems = (checkedItems) =>
      Array.from(checkedItems)
        .map((checkedItem) => checkedItem.getAttribute('value'))
        .join('|');

    const getFormValue = (form, fv) => {
      const formData = {};

      Object.keys(fv.getFields()).forEach((key) => {
        const element = form.querySelector(`[data-fv-name="${key.replace(/\[\]/g, '')}"]`);
        const parentElem = element.closest('[data-input-group-parent]');

        if ((element.type === 'radio' && parentElem) || (element.type === 'checkbox' && parentElem)) {
          const selectedInputs = parentElem.querySelectorAll('input:checked');
          const itemValues = joinActiveItems(selectedInputs);
          formData[key] = itemValues || '';
        } else {
          formData[key] = fv.getElementValue(key, element);
        }
      });

      return { inputs: JSON.stringify(formData) };
    };

    /**
     * @typedef {Object} AxiosOptions - Options object for Axios request.
     * @property {Object} headers - Request headers.
     * @property {string} headers.Content-Type - Content type for the request.
     * @property {string} [method] - HTTP method (e.g., GET, POST, PUT, etc.).
     * @property {string} [url] - Request URL.
     * @property {Object} [params] - URL parameters.
     * @property {Object} [data] - Request payload data.
     * @property {Object} [auth] - Authentication credentials (e.g., { username: 'user', password: 'pass' }).
     * @property {number} [timeout] - Request timeout in milliseconds.
     * @property {boolean} [withCredentials] - Indicates whether cross-site Access-Control requests
     *                                         should be made using credentials.
     */

    /**
     * @typedef {Object} Options - Options object for the onFormSubmit function.
     * @property {AxiosOptions} [axiosOptions] - Options for the Axios request.
     * @property {Object} formData - The form data to submit.
     * @property {string} [recaptchaKey] - Recaptcha key.
     * @property {string} [recaptchaAction] - Recaptcha action.
     * @property {number} [timeout] - Timeout for the request in milliseconds.
     * @property {string} [url] - Url of the request.
     * @property {boolean} [forceError] - You should use this to force an form error, to test UI on error.
     */

    /**
     * Simulates a form submission using Axios.
     * @param {Options} [options] - Additional options for the request.
     * @returns {Promise} - A promise that resolves to the Axios response.
     */

    const onFormSubmit = async (options = { formData: {} }) => {
      // Default values
      if (!options.formData.lang) {
        options.formData.lang = localData.lang;
      }

      // FE / Preview submission of the form without API
      if (isFractal()) {
        console.warn('Fractal - Simulating request');
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            if (options.forceError) {
              reject(new Error('Simulated error'));
              return;
            }

            console.warn('Simulated success, FormData:', options.formData);
            resolve();
          }, options.timeout || 250);
        });
      }

      if (options.recaptchaKey && options.recaptchaAction) {
        const token = await grecaptcha.execute(options.recaptchaKey, { action: options.recaptchaAction });
        const nonce = await getNonceForAction(options.recaptchaAction);

        options.formData = { ...options.formData, action: options.recaptchaAction, nonce, token };
      }

      // Make a request to the API
      return axios.post(options.url || localData.siteURL, options.formData, {
        ...options.axiosOptions,
      });
    };

    // **************************************************

    return {
      breakpointSm,
      breakpointMd,
      breakpointLg,
      windowWidth,
      attachEvent,
      animate,
      validateEmailInput,
      debounce,
      ResponsiveBackgroundImage,
      responsiveBgImagesLoop,
      slideUp,
      slideDown,
      slideToggle,
      calcVh,
      debounceCalcVh,
      clickHandler,
      addAnimateClass,
      setHeight,
      equalheight,
      isVisible,
      addScrollingClass,
      setOffsets,
      isFractal,
      getNonceForAction,
      joinActiveItems,
      getFormValue,
      onFormSubmit
    };
  })();

// **************************************************

  injection.responsiveBgImagesLoop();

  window.addEventListener('resize', () => {
    injection.debounceCalcVh();
  });

  window.addEventListener('load', () => {
    injection.equalheight('.equal-height');
  });

  window.addEventListener('resize', () => {
    setTimeout(() => {
      injection.equalheight('.equal-height');
    });
  });
});
